import css from './UserTicket.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import DataTestId from 'meta/dataTestId'
import { IWalletEntityType } from 'meta/pages/v4/wallet'
import { CookieClient, CookieName } from 'utils/cookie'

import { ButtonWhiteRed } from 'components/Actions/Action'
import { ButtonBlackWhite } from 'components/Actions/Action/Button'
import Img from 'components/Media/Img'
import { useV4TicketStatus } from 'components/Pages/Wallet/hooks/useTicketStatus'
import { useFunUrl, useUrlCloudfront } from 'hooks/useEnv'

import { UserTicketProps } from './UserTicketContainer'

const UserTicket: React.FC<UserTicketProps> = (props) => {
  const { baseProps, ticketData, typeTicketData } = props
  const { walletEventData, eventData, idx } = baseProps

  const { t } = useTranslation()
  const urlCloudfront = useUrlCloudfront()
  const funUrl = useFunUrl()

  const status = useV4TicketStatus({ userTicketData: ticketData, walletEventData })

  const onPrint = async () => {
    const authToken = CookieClient.get(CookieName.TOKEN)
    const printUrl = `${funUrl}/pdf/index.php?e=${eventData.id}&s=${ticketData.secret}&token=${authToken}`
    window.open(printUrl, '_blank')
  }

  return (
    <div className={css.userTicket} data-testid={DataTestId.wallet.userTicketDesktop}>
      <div
        className={classNames(css.userTicket__oneRow, css.userTicket__count)}
        style={{ backgroundImage: `url(${urlCloudfront}/images/wallet/ticket_red_h.svg)` }}
      >
        <h4>{idx + 1}</h4>
      </div>
      {walletEventData.type !== IWalletEntityType.good_service && (
        <div>
          <h4 className={css.userTicket__infoTitle}>{t('wallet:name')}:</h4>
          <h4>{ticketData.firstName ? `${ticketData.firstName} ${ticketData.lastName}` : '-'}</h4>
        </div>
      )}
      <div>
        <h4 className={css.userTicket__infoTitle}>{t('wallet:fiscalSeal')}:</h4>
        <h4>{ticketData.fiscalData?.emission?.fiscalSeal ? ticketData.fiscalData?.emission?.fiscalSeal : '-'}</h4>
      </div>
      {ticketData.secret ? (
        <ButtonWhiteRed className={classNames(css.userTicket__oneRow, css.userTicket__btnPrint)} onClick={onPrint}>
          <Img src={`/wallet/print.svg`} />
          <div>{t('wallet:print')}</div>
        </ButtonWhiteRed>
      ) : (
        <div className={classNames(css.userTicket__oneRow, css.userTicket__btnPrint)} />
      )}
      {(ticketData.fiscalData.receiptUri ||
        ticketData.fiscalData.receiptUris ||
        ticketData.fiscalData.creditNoteUris) && (
        <ButtonBlackWhite
          className={classNames(css.userTicket__twoRow, css.userTicket__btnReceipt)}
          onClick={() => {
            if (ticketData.fiscalData.receiptUri) {
              window.open(ticketData.fiscalData.receiptUri, '_blank')
            }

            if (ticketData.fiscalData.receiptUris) {
              ticketData.fiscalData.receiptUris.map((uri) => window.open(uri, '_blank'))
            }

            if (ticketData.fiscalData.creditNoteUris) {
              ticketData.fiscalData.creditNoteUris.map((uri) => window.open(uri, '_blank'))
            }
          }}
        >
          <h5>{t('wallet:show_receipt')}</h5>
        </ButtonBlackWhite>
      )}
      <div>
        <h4 className={classNames(css.userTicket__infoTitle, css.userTicket__infoRow)}>{t('wallet:ticketType')}:</h4>
        <h4>{typeTicketData.notes}</h4>
      </div>
      <div>
        <h4 className={classNames(css.userTicket__infoTitle, css.userTicket__infoRow)}>{t('wallet:statusLabel')}:</h4>
        <h4 data-testid={DataTestId.wallet.ticketStatus}>{status}</h4>
      </div>
      <Img className={css.userTicket__imgCorner} src="/wallet/ticket_corner_grey.svg" />
    </div>
  )
}

export default UserTicket
